import React from 'react';
import { WrappedMessage } from '../../../../utils';
import messages from '../../../displayMessages';
import { OverviewItem } from './CareerDetailsPage';

interface BasicsPillProps {
    title: string;
    info: string;
    description: string;
    icon: string;
    targetSectionId?: string;
}

export const BasicPill: React.FC<BasicsPillProps> = ({title, info, description, icon, targetSectionId}) => {
    const handleReadMore = () => {
        if (targetSectionId) {
            const targetElement = document.getElementById(targetSectionId);
            if (targetElement) {
                targetElement.scrollIntoView({behavior: 'smooth'});
            }
        }
    };

    return (
        <div className='pill'>
            <div className='pill-content'>
                <div className='pill-info-title'>{title}</div>
                <h4 className='pill-info'>{info}</h4>
                <div className='pill-info-description'>
                    {description.split(' ').slice(0, 7).join(' ')}
                    <span>
                        <button onClick={handleReadMore} className='read-more-button'>
                          <WrappedMessage message={messages.readMoreBasicSummary}/>
                        </button>
                    </span>
                </div>
            </div>
            <div className='pill-icon'>
                <img src={icon}/>
            </div>
        </div>
    );
};

interface CareerOverviewProps {
    items: OverviewItem[];
}

const CareerOverview: React.FC<CareerOverviewProps> = ({items}) => {
    return (
        <div className='quick-look-section'>
            <h2>
                <WrappedMessage message={messages.careerOverviewSectionHeading} />
            </h2>
            <div className='quick-look-container'>
                {items.map((item, index) => (
                    <BasicPill key={index} title={item.title} description={item.description} icon={item.icon} info={item.info}/>
                ))}
            </div>
        </div>
    );
};

export default CareerOverview;

